import { useEffect, useState } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { AdaptiveFormFieldConfig } from '@elements';
import { useProposalStore } from '@store/proposal';

/*
  - Fetches data and sets values.
  - Sets defaultValues for all fields in the form.
*/
export const useComponentProps = <T extends AdaptiveFormFieldConfig>(
  config: T
): T['componentProps'] | null => {
  const { componentProps, setComponentProps } = config;
  const { currentStep, productDetails } = useProposalStore((state) => ({
    currentStep: state.currentStep,
    productDetails: state.productDetails
  }));
  const { getValues } = useFormContext();
  const [dynamicProps, setDynamicProps] = useState<T['componentProps'] | null>(null);

  // Only watch if this field has a condition
  const watchedFields = useWatch({
    name: currentStep?.watchForChanges as any,
    disabled: typeof config?.setComponentProps !== 'function'
  });

  useEffect(() => {
    if (typeof setComponentProps === 'function') {
      const newProps = setComponentProps(getValues, productDetails);
      setDynamicProps(newProps);
    }
  }, [setComponentProps, getValues, watchedFields, productDetails]);

  if (dynamicProps) {
    return dynamicProps;
  }

  return componentProps;
};
